// extracted by mini-css-extract-plugin
export default {"terms":"NewSmsConfirmation-module__terms__HntpY"};